var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCsv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_74_3763)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_74_3763",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.813 0H0V14.996H16.813V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_74_3763)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5254 0H15.9654C16.1905 0.000264653 16.4063 0.0897976 16.5654 0.248959C16.7246 0.40812 16.8141 0.623912 16.8144 0.849V3.749H10.5264L10.5254 0Z",
    fill: "#31C684"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8134 3.74902H10.5254V7.49802H16.8134V3.74902Z",
    fill: "#21A664"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8134 7.49805H10.5254V11.247H16.8134V7.49805Z",
    fill: "#0E7941"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.79135 0H10.5254V3.749H3.94336V0.849C3.94362 0.624085 4.03301 0.408444 4.19196 0.249311C4.3509 0.0901787 4.56644 0.000529056 4.79135 0Z",
    fill: "#21A262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5254 3.74902H3.94336V7.49802H10.5254V3.74902Z",
    fill: "#107941"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5254 7.49805H3.94336V11.247H10.5254V7.49805Z",
    fill: "#105D31"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5244 14.996H4.79041C4.56644 14.996 4.35155 14.9075 4.19254 14.7498C4.03352 14.5921 3.94325 14.3779 3.94141 14.154V11.2469H16.8164V14.154C16.8146 14.3779 16.7243 14.5921 16.5653 14.7498C16.4063 14.9075 16.1914 14.996 15.9674 14.996H10.5244Z",
    fill: "#105D2F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.849 3.14798H7.692C7.91709 3.14824 8.13288 3.23777 8.29204 3.39693C8.4512 3.5561 8.54074 3.77189 8.541 3.99698V10.934C8.54074 11.1591 8.4512 11.3749 8.29204 11.534C8.13288 11.6932 7.91709 11.7827 7.692 11.783H0.849C0.623739 11.7827 0.407795 11.693 0.248606 11.5337C0.0894159 11.3743 -1.5589e-07 11.1582 0 10.933V3.99598C0.000264653 3.77089 0.0897976 3.5551 0.248959 3.39594C0.40812 3.23677 0.623912 3.14724 0.849 3.14697",
    fill: "#10864A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.29883 5.17896H3.29883L4.26782 6.70296L5.23682 5.17896H6.22582L4.76283 7.47896L6.22582 9.77895H5.23682L4.26782 8.25496L3.29883 9.77895H2.29883L3.76882 7.47896L2.29883 5.17896Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_74_3763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.813,
    height: 14.996,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsv);
export default __webpack_public_path__ + "static/media/csv.67d9a681d1881ba4fb6e8b44000aa25e.svg";
export { ForwardRef as ReactComponent };